export default __webpack_public_path__ + "static/media/af.03412c91.svg";